import React from 'react'
import PropTypes from 'prop-types'

// components
import Tile from './Tile.js'

class TilesList extends React.Component {
	static propTypes = {
		activeIndex: PropTypes.number,
		className: PropTypes.string,
		isMoney: PropTypes.bool.isRequired,
		name: PropTypes.string.isRequired,
		onChange: PropTypes.func,
		tiles: PropTypes.array,
		vertical: PropTypes.bool
	}

	static defaultProps = {
		activeIndex: -1,
		className: '',
		isMoney: false,
		onChange: () => {
		},
		tiles: [],
		vertical: false,
	}

	handleOnChange = (index) => {
		this.props.onChange(index)
	}

	render() {
		return (
			<div className='row mb-3'>
				{this.props.tiles.map((item, index) => [
					<div
						className={this.props.vertical ? 'domex-tile-wrapper-vertical' : 'col-4 col-sm-3 col-md-2 col-lg-1'}
						key={item.id}
					>
						<Tile
							active={index === this.props.activeIndex}
							id={`${this.props.name}-${index}`}
							isMoney={this.props.isMoney}
							label={item.name}
							onClick={this.handleOnChange}
							value={index}
						/>
					</div>,
					<div
						className=''
						key={`${item.id}-text`}
					>
						{item.text && <div className='domex-text'>{item.text}</div>}
					</div>
				])}
			</div>
		)
	}
}

export default TilesList
